import { ElMessage } from 'element-plus';
import { maintainExpandMode } from './expandMode';
import type { QuoteSources } from './types';
import { resolveIdCotizacion } from './quoteId';

export interface ShareResult {
  success: boolean;
  error?: string;
}

export interface ShareMessages {
  success: string;
  failureFallback: string;
  unknownError: string;
}

const errorToast = (message: string): void => {
  ElMessage.error({ message, duration: 4000, showClose: true });
};

export const getShareQuoteId = (sources: QuoteSources): number | undefined => {
  const idCotizacion = resolveIdCotizacion(sources);
  if (!idCotizacion) ElMessage.warning('No se puede enviar: ID de cotización no disponible');
  return idCotizacion || undefined;
};

export const getShareValidity = (sources: QuoteSources): string | undefined => {
  const { cotizacionData } = sources.quoteData;
  return cotizacionData?.finVigencia ?? cotizacionData?.inicioVigencia;
};

export async function runShare(send: () => Promise<ShareResult>, messages: ShareMessages): Promise<void> {
  try {
    const result = await send();
    if (result.success) {
      ElMessage.success({ message: messages.success, duration: 3000, showClose: true });
    } else {
      errorToast(result.error || messages.failureFallback);
    }
    maintainExpandMode();
  } catch (error) {
    errorToast(error instanceof Error ? error.message : messages.unknownError);
  } finally {
    maintainExpandMode();
  }
}
